import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { Container, theme, useResponsive } from '@sg/garnish';

import { PARTNER_LINE_ITEM_CONTENT_MAX_WIDTH } from '../../PartnerLineItem.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemDetails = (props: PropsWithChildren) => {
  const { children } = props;

  const { match } = useResponsive();

  // ─── Styles ──────────────────────────────────────────────────────────

  const sectionStyles = [styles.section, match([styles.sectionXS, styles.sectionSM])];
  const containerStyles = [styles.container, match([styles.containerXS, undefined])];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={sectionStyles}>
      <Container style={containerStyles}>{children}</Container>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  section: {
    alignItems: 'center',
    alignSelf: 'stretch',
    gap: theme.spacing['4'],
  },
  sectionXS: {
    paddingVertical: theme.spacing['6'],
  },
  sectionSM: {
    paddingVertical: theme.spacing['10'],
  },
  container: {
    alignItems: 'center',
    gap: theme.spacing['6'],
    maxWidth: PARTNER_LINE_ITEM_CONTENT_MAX_WIDTH,
  },
  containerXS: {
    paddingHorizontal: theme.spacing['6'],
  },
});
